import Chip, { ChipProps } from './Chip';

export type { ChipProps };
export default Chip;
